import { storeToRefs } from 'pinia';
import { nextTick } from 'vue';
import { Route } from 'vue-router';
import { getFromSessionStorage } from '@/apps/order/helper';

import { useOrdersCreateFormDataStore, useOrdersCreateCustomFieldsStore } from '@/apps/order/stores/ordersCreate';

import OrdersCreateFormDataInterface from '@/apps/order/interfaces/OrdersCreateFormDataInterface';
import { CustomFieldRequiredBySourceType } from '@/apps/order/interfaces/CustomFieldValuesInterface';

const hasFormData = async (to: Route): Promise<void> => new Promise<void>((resolve, reject) => {
  const ctx = to.meta?.ctx;
  nextTick(async () => {
    try {
      const formDataStore = useOrdersCreateFormDataStore();
      const customFieldsStore = useOrdersCreateCustomFieldsStore();
      const {
        formData,
        alreadyFetched,
        selectedTariffs,
        continueAsLead,
      } = storeToRefs(formDataStore);
      const {
        customFieldRequiredBySource,
      } = storeToRefs(customFieldsStore);

      let orderFormData;
      let selectedTariffsData;
      let requiredBySourceData;

      if (!alreadyFetched.value) {
        orderFormData = getFromSessionStorage<OrdersCreateFormDataInterface>(`${ctx}.formData`);
        selectedTariffsData = getFromSessionStorage<Record<string, any>>(`${ctx}.selectedTariffs`);
        continueAsLead.value = getFromSessionStorage<boolean>(`${ctx}.canContinueAsLead`) || false;
        requiredBySourceData = getFromSessionStorage<CustomFieldRequiredBySourceType>(`${ctx}.customFieldRequiredBySource`);

        alreadyFetched.value = true;
      }

      if (orderFormData !== undefined) {
        formData.value = orderFormData;
      }

      if (selectedTariffsData !== undefined) {
        selectedTariffs.value = selectedTariffsData;
      }

      if (requiredBySourceData !== undefined) {
        customFieldRequiredBySource.value = requiredBySourceData;
      }

      resolve();
    } catch (e) {
      reject(new Error(['fetch form data failed', e].join(' ')));
    }
  });
});

export default hasFormData;
